import { render } from "./wms-romaneio-editar.vue?vue&type=template&id=10b737ee"
import script from "./wms-romaneio-editar.vue?vue&type=script&lang=js"
export * from "./wms-romaneio-editar.vue?vue&type=script&lang=js"

import "./wms-romaneio-editar.vue?vue&type=style&index=0&id=10b737ee&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__